var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2.053C8.831.223 6.452-.383 4.351.233 1.893.953 0 3.283 0 6.815c0 3.535 2.196 6.823 4.458 9.16 1.146 1.183 2.347 2.163 3.378 2.853.515.345 1 .626 1.423.824.39.182.838.348 1.241.348.403 0 .851-.166 1.24-.348.425-.198.91-.479 1.424-.824 1.03-.69 2.232-1.67 3.378-2.853C18.804 13.638 21 10.35 21 6.815 21 3.283 19.107.953 16.649.233c-2.1-.616-4.48-.01-6.149 1.82z"
  })));
}

export default SvgHeart;